import type { JSX } from 'react';

import BillingItemRemitDetails from '@/components/BillingItemRemitDetails/BillingItemRemitDetails';
import Card from '@/ui/components/Card';
import { DataRow } from '@/ui/components/DataList';
import Heading from '@/ui/components/Heading';

import NonBillableBillingItem from '../NonBillableBillingItem';
import RefreshBillingItem from '../RefreshBillingItem';

import BillingDetails from './components/BillingDetails/BillingDetails';
import Claim from './components/Claim';
import { Props } from './types';

const BillingItem = ({
  billingItem,
  charts,
  encounterType,
  refetchEncounter
}: Props): JSX.Element | null => {
  if (!billingItem)
    return (
      <Card className="p-2">
        <Heading className="truncate mb-4" text="Billing" title="Billing" value={3} />
        <DataRow label="Claim status" content="Pending" />
        <NonBillableBillingItem billingItem={billingItem} encounterType={encounterType} />
      </Card>
    );

  return (
    <>
      <Card className="p-2">
        <div className="flex justify-between mb-4">
          <Heading text="Billing" title="Billing" value={3} />
        </div>
        <BillingDetails billingItem={billingItem} charts={charts} />
      </Card>
      <BillingItemRemitDetails billingItem={billingItem} />
      <Card>
        <Claim claim_rows={billingItem?.healthie_claim_rows} />
        <NonBillableBillingItem billingItem={billingItem} encounterType={encounterType} />
        {refetchEncounter && (
          <RefreshBillingItem billingItem={billingItem} refetchEncounter={refetchEncounter} />
        )}
      </Card>
    </>
  );
};

export default BillingItem;
